var jade = require("/home/runner/work/banquetNinja/banquetNinja/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<ninja-grid no-data-text=\"No ingredients yet...\" grid-title=\"Ingredients\" doc-svc=\"vm.docSvc\" list=\"vm.docSvc.doc.ingredients\" create-method=\"openAddIngredient\" update-method=\"\" delete-method=\"removeIngredient\" add-toggle=\"vm.openIngredientPanel\" fields=\"{quantity: {input: 'text', header: 'Quantity', order: 10, width: 10, type: 'number'}, unit: {input: 'select', header: 'Unit', order: 20, width: 15, type: 'string', selectOptions: vm.unitOptions},name: {input: 'text', header: 'Ingredient', order: 30, width: 30, type: 'string'}, prepNotes: {input: 'text', header: 'Prep Notes', order: 40, width: 45, type: 'string'}}\"></ninja-grid>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./app/features/production/recipes/tabs/tab-ingredients.jade
// module id = 215
// module chunks = 0